import { configureStore } from "@reduxjs/toolkit";
import fileReducer from "./modules/files";
import userReducer from "./modules/user";

export const store = configureStore({
  reducer: {
    files: fileReducer,
    user: userReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
